import React from 'react'
import Text from '../../atoms/Text/Text'

// Generic "use a computer" screen shown when the portal is not available on a phone.
// Unlike PhoneBlockingDialog (used at login), this does not claim a sign-in email was sent,
// so it is safe to show to users who are already authenticated.
export const MobileRestriction: React.FC = () => (
  <div data-testid='mobile-restriction-container' className='bg-black flex justify-center items-center min-h-screen w-full p-4'>
    <div className='glow-effect max-w-md w-full'>
      <div className='diamond-corner p-1 bg-dopage-lightGreen w-full'>
        <div className='inner bg-black'>
          <div className='py-8 px-4 flex flex-col justify-center items-center text-dopage-darkGreen'>
            <h2 data-testid='mobile-restriction-title' className='text-xl md:text-2xl font-bold mb-6 w-full text-center'>
              <Text
                className='font-bold text-center w-full'
                bold
                size='LG'
                text='Grab your computer!'
              />
            </h2>
            <p data-testid='mobile-restriction-message' className='text-base md:text-xl text-center text-dopage-lightGreen mb-4 w-full'>
              <Text
                className='text-center w-full'
                size='SM'
                text='The DopaGE Overdose Prevention Portal is not accessible via mobile device. Please sign in from a laptop or desktop computer.'
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default MobileRestriction
